import classnames from 'classnames';
import _ from 'lodash';
import moment from 'moment';

/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import Localized from '../../../shared/components/Localized';

export default class TimelineMarkers extends React.Component {
  static propTypes = {
    range: PropTypes.object,
    offset: PropTypes.object,
    region: PropTypes.string
  };

  render() {
    const { offset, range, region, selectedDate } = this.props;
    const now = moment.tz(moment().subtract(offset), region);
    const visibleRange = moment.duration(range);
    const cutoff = moment.tz(now, region).subtract(visibleRange);
    const days = now.diff(cutoff, 'days');
    const markers = [];
    const nextMidnight = moment
      .tz(now, region)
      .add(1, 'day')
      .startOf('day');
    const selectedDayMidnight =
      selectedDate && Object.keys(selectedDate).length
        ? moment
            .tz(selectedDate, region)
            .startOf('day')
            .valueOf()
        : 0;
    const startIndex = offset.asMilliseconds() === 0 ? 0 : 1;
    for (let i = startIndex; i < days + 1; i++) {
      const markerTime = moment(nextMidnight).subtract(1 * i, 'days');
      const isNowMarker = (i === 0) & (offset.asMilliseconds() === 0);
      const right =
        _.clamp(
          (now.diff(markerTime) / visibleRange.asMilliseconds()) * 100,
          0,
          100
        ) + '%';
      const markerStyle = { right };
      const isSelectedDateMarker = markerTime.valueOf() === selectedDayMidnight;
      const markerClasses = classnames({
        'timeline-marker': true,
        'timeline-marker--now': isNowMarker,
        'timeline-marker--selected-date': isSelectedDateMarker
      });
      if (isNowMarker) {
        markers.push(
          <div key='now' className={ markerClasses } style={ markerStyle }>
            <div id='nowFlagLabel' className='timeline-marker-label'>
              <Localized
                modelName="timeline"
                modelKey="now"
                modelAttribute="label"
              />
            </div>
          </div>
        );
      } else {
        markers.push(
          <div key={markerTime} className={markerClasses} style={markerStyle}>
            <div id={`timeline-marker-${i}`} className="timeline-marker-label">
              {markerTime.format('M/D')}
            </div>
          </div>
        );
      }
    }
    return <div className="timeline-markers">{markers}</div>;
  }
}
